export default __webpack_public_path__ + "static/media/bnr5.cb7bee4e.jpg";